import { Navigate, Outlet } from "react-router-dom";
import { jwtDecode } from "jwt-decode";


const isTokenValid = () => {
    const token = localStorage.getItem("token");
    if (!token) return false;
	// return true;

    try {
        const decoded = jwtDecode(token);
        const currentTime = Date.now() / 1000;
        return decoded.expiry > currentTime; // Token is valid if expiration time is in the future
    } catch (error) {
        return false;
    }
};

const ProtectedRoute = () => {
    return isTokenValid() ? <Outlet /> : <Navigate to="/" />;
};

export default ProtectedRoute;
